import { PlatformService } from '../../platform/platform.service';
import { EnvVarUserOfflineAndroidDao } from './envvaruser-offline-android.dao';
import { EnvVarUserOfflineWebDao } from './envvaruser-offline-web.dao';
import { EnvVarUserOfflineDao } from './envvaruser-offline.dao';

const EnvVarUserOfflineDaoFactory = (platformService: PlatformService) => platformService.isAndroidApp() ? 
    new EnvVarUserOfflineAndroidDao() : new EnvVarUserOfflineWebDao();

export const EnvVarUserOfflineDaoProvider = { 
    provide: EnvVarUserOfflineDao,
    useFactory: EnvVarUserOfflineDaoFactory,
    deps: [PlatformService]
};